// extracted by mini-css-extract-plugin
module.exports = {"callRoomExitModal":"_1IXrA","actions":"_3VfDK","positiveButton":"_2XTXx"};